import request from "@/common/request";
import { Page, Eventos }  from "@/models";
import { AxiosRequestConfig } from "axios";

const basePath = '/events'

export const findAll = (params?: any, config?: AxiosRequestConfig): Promise<Page<Eventos>> =>
	request.get(`${basePath}/buscar`, { params, ...config })